<template>
  <!-- banner -->
  <Slider></Slider>
  <!-- END banner -->

  <!-- soluções -->
  <section v-if="topoSolucoes != ''" class="ftco-section ftco-services espaco100"
    style="background-image: url('/images/use_your_illusion.png'); background-repeat: repeat;">
    <div class="container">
      <div class="row">
        <div class="col-md-12 d-flex align-self-stretch">
          <div class="pb-4 heading-section heading-section-white">
            <h2 class="mb-3">{{ topoSolucoes[0].itiNome }}</h2>
            <p v-html="topoSolucoes[0].itiResumo1" class="mb-4 textoEditor"></p>
          </div>
        </div>
        <!-- quadros -->
        <div v-for="solucoes in listaSolucoes" :key="solucoes.itiId" class="col-md-3 d-flex align-self-stretch">
          <div class="services">
            <div class="d-flex justify-content-end"><router-link
                :to="'/SolucaoTecnica/' + solucoes.itiId + '/' + formataLink(solucoes.itiNome)">
                <div class="icon d-flex"><span :class="solucoes.itiCampoExtra4"></span></div>
              </router-link></div>
            <div class="media-body"><router-link
                :to="'/SolucaoTecnica/' + solucoes.itiId + '/' + formataLink(solucoes.itiNome)">
                <h3 class="heading mb-3">{{ solucoes.itiNome }}</h3>
              </router-link>
            </div>
            <router-link :to="'/SolucaoTecnica/' + solucoes.itiId + '/' + formataLink(solucoes.itiNome)"
              class="btn-custom d-flex align-items-center justify-content-center"><span
                class="fa fa-chevron-right"></span></router-link>
          </div>
        </div>
      </div>
    </div>

  </section>
  <!-- END soluções -->

  <!-- empresa -->
  <section class="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
    <div v-if="empresa != ''" class="container">
      <div class="row d-flex">
        <div class="col-md-12 about-intro">
          <div class="row d-flex">
            <div class="col-md-6 d-flex align-items-stretch">
              <div class="img d-flex align-items-center align-self-stretch justify-content-center"
                :style="{ backgroundImage: 'url(' + $imgURL + empresa[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
              </div>
            </div>
            <div class="col-md-6 pl-md-5 py-5">
              <div class="row justify-content-start pb-3 pt-md-5">
                <div class="col-md-12 heading-section  ">
                  <span class="subheading">{{ empresa[0].itiNome }}</span>
                  <h2 class="mb-4">{{ empresa[0].itiReferencia }}</h2>
                  <p v-html="empresa[0].itiResumo1"></p>

                  <div class="year-stablish d-flex">
                    <div class="icon2 d-flex align-items-center justify-content-center"><span
                        class="flaticon-light-bulb">{{ empresa[0].itiCampoExtra3 }}</span></div>
                    <div class="text pl-4">
                      <strong class="number">{{ empresa[0].itiCampoExtra1 }}</strong>
                      <span>{{ empresa[0].itiCampoExtra2 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END empresa -->

  <!-- numeros -->
  <section class="ftco-section ftco-counter img" id="section-counter" style="background-image:url('images/bg_4.jpg');">
    <div class="overlay"></div>
    <div v-if="numeros != ''" class="container">
      <div class="row">

        <template v-for="numerosTxt in numeros" :key="numerosTxt.itiId">
          <div class="col-md-3 col-6 text-center">
            <div style="display: inline-flex; align-items: center; justify-content: center;">
              <VueJsCounter :start="0" :end="numerosTxt.itiNome" :duration="7000" class="number counter-wrap" style="
        font-weight: 700; font-size: 52px; color: #fff;" />
              <strong style="
        font-weight: 700; font-size: 52px; color: #fff;">{{ numerosTxt.itiCampoExtra1 }}</strong>
            </div><br>
            <span style="text-transform: uppercase;
        font-weight: 700; font-size: 18px; color: #fff;">{{ numerosTxt.itiReferencia }}</span>
          </div>
        </template>

      </div>
    </div>
  </section>
  <!-- END numeros -->

  <!-- depoimentos -->
  <section v-if="depoimentos != ''" class="ftco-section testimony-section ftco-no-pt bg-light">
    <div class="overlay"></div>
    <div v-if="listaDepoimentos != ''" class="container" style="padding-top: 100px;">
      <div class="row pb-4">
        <div class="col-md-12 heading-section  ">
          <span class="subheading">Depoimentos</span>
          <h2 class="mb-4">O que Falam sobre Nós</h2>
        </div>
      </div>
    </div>
    <div class="container px-lg-5">
      <div class="row  ">
        <div class="col-md-12">
          <div class="carousel-testimony owl-carousel">

            <div  class="item">
              <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="3" :space-between="20"
                :breakpoints="{ 768: { slidesPerView: 3 }, 0: { slidesPerView: 1 } }">
                <SwiperSlide v-for="(item, index) in listaDepoimentos" :key="index">
                  <div class="testimony-wrap py-4">
                    <div class="text">
                      <p v-html="item.itiResumo1" class="mb-4"></p>
                      <div class="d-flex align-items-center">
                        <div class="user-img">
                          <img style="width: 80px; border-radius: 50%;"
                            :src="$imgURL + item.insInstitucionalImagens[0].itgUrlImagem">
                        </div>
                        <div class="pl-3">
                          <p class="name">{{ item.itiNome }}</p>
                          <span class="position">{{ item.itiReferencia }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END depoimentos -->

   <PageDepoimentosApiGoogle></PageDepoimentosApiGoogle>

  <!-- blog -->
  <section v-if="blogHome.length > 0" class="ftco-section ftco-no-pb">
    <div class="container">
      <div class="row justify-content-center pb-4">
        <div class="col-md-12 heading-section text-center  ">
          <span class="subheading">blog</span>
          <h2 class="mb-4">últimas noticias</h2>
        </div>
      </div>

      <div class="row d-flex">
        <div v-for="noticia in blogHome" :key="noticia.itiId" class="col-md-4  ">
          <div class="blog-entry">
            <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
              class="block-20"><img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" class="img-fluid" style="height: 200px;border: 1px solid #cccccc;border-radius: 5px;">
            </router-link>
            <div class="text d-block text-center">
              <h3 class="heading"><router-link
                  :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">{{ noticia.itiNome
                  }}</router-link></h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END blog -->

  <!-- callaction -->
  <PageCallAction></PageCallAction>
  <!-- END callaction -->


</template>

<script>
import PageCallAction from '@/components/PageCallAction.vue';
import PageDepoimentosApiGoogle from '@/components/PageDepoimentosApiGoogle.vue';
import { useHead } from '@vueuse/head'
import axios from 'axios'
import { Swiper, SwiperSlide } from 'swiper/vue';
import Slider from '@/components/PageSlider2.vue';
import VueJsCounter from 'vue-js-counter';

export default {
  name: 'HomeView',
  components: {
    PageCallAction,
    PageDepoimentosApiGoogle,
    Swiper,
    SwiperSlide,
    Slider,
    VueJsCounter,
  },

  data: () => ({
    topoBanner: [],
    topoSolucoes: [],
    listaSolucoes: [],
    empresa: [],
    numeros: [],
    numerosTxt: [],
    listaDepoimentos: [],
    blogHome: [],
    depoimentos:[],
    seoHome: [],

  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, '');
    },

    carregaMetas(titulo, texto, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: palavrasChave }
        ],
      })
    },

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },
  },

  created() {   
     //aqui busca soluções
    axios.get('/Process/InsInstitucional/institucional/50/seohome/0/x')
      .then(response => {
        this.seoHome = response.data;
         let seoHome0 = this.seoHome[0];
         seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
         seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

         this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });


    //aqui busca soluções
    axios.get('/Process/InsInstitucional/institucional/35/toposolucoes/0/x')
      .then(response => {
        this.topoSolucoes = response.data;
        //console.log('topo soluções')
        //console.log(this.topoSolucoes)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca soluções
    axios.get('/Process/InsInstitucional/institucional/44/listasolucoes/0/x')
      .then(response => {
        this.listaSolucoes = response.data;
        //console.log('lista soluções')
        //console.log(this.listaSolucoes)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca empresa
    axios.get('/Process/InsInstitucional/institucional/36/apresentacaohome/0/x')
      .then(response => {
        this.empresa = response.data;
        //console.log('empresa')
        //console.log(this.empresa)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca imagem números
    axios.get('/Process/InsInstitucional/institucional/25/numerosimgfundo/0/x')
      .then(response => {
        this.numeros = response.data;
        //console.log('números')
        //console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca números
    axios.get('/Process/InsInstitucional/institucional/14/numeros/0/x')
      .then(response => {
        this.numeros = response.data;
        //console.log('números')
        console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca depoimentos
    axios.get('/Process/InsInstitucional/institucional/13/depoimentos/0/x')
      .then(response => {
        this.listaDepoimentos = response.data;
        //console.log('depoimentos')
        //console.log(this.listaDepoimentos)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca noticias
    axios.get('/Process/InsInstitucional/institucional/48/listablog/3/itiData1')
      .then(response => {
        this.blogHome = response.data;
        //console.log('noticias home')
        //console.log(this.blogHome)
      })
      .catch(error => {
        console.error(error);
      });
  },
}

</script>

<style scoped></style>